# frozen_string_literal: true

module Engine
  module Game
    module G1804
    end
  end
end
